import React from 'react'
import { About, Testimonial, Footer } from '../components'
import FrequentlyAQ from '../components/FrequentlyAQ'
import Meta from '../components/common/Meta'
import image from '../assets/images/services/services-header.jpg'

function AboutPage() {
  return (
    <div>
      <Meta
        title="Building Tommorrow | Rwanda Construction Support"
        description="Professional assistance for building permits, occupation permits, RDB submissions, inspections, and construction approval drawings in Rwanda."
        keywords="
          Building permit services Rwanda, Occupation permit assistance,
          RDB construction submission, Construction approval drawings,
          Building inspection services,
          Permis de construire Rwanda,
          Assistance permis d’occupation,
          Dossiers RDB construction,
          Uruhushya rwo kubaka,
          Uruhushya rwo guturamo inzu,
          Gufasha mu nyandiko za RDB,
          Construction drawings Rwanda,
          As-built drawings services,
          Technical building drawings,
          As-built drawings Kigali
          "
          />

      <header
        className="relative min-h-[320px] flex items-center justify-center bg-cover bg-center"
        style={{ backgroundImage: `url(${image})` }}
        >
        {/* Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-60"></div>

        {/* Content */}
        <div className="relative text-center px-4 z-10">
          <h1 className="text-4xl md:text-5xl font-extrabold text-white uppercase tracking-wide">
            More About Us
          </h1>
          <p className="mt-4 text-lg md:text-xl text-gray-200 max-w-2xl mx-auto">
            We would like to tell more about our company and its values.
          </p>
        </div>
      </header>

      <About />
      {/* <Testimonial /> */}
      <FrequentlyAQ />
      <Footer />
    </div>
  )
}

export default AboutPage
